import React, {ReactElement} from 'react';

const renderEmptyState = (): ReactElement => {
  return (
    <div className="admin-StoreAnalytics-emptyState">
      No data found for this time duration.
    </div>
  );
};

export default renderEmptyState;
